package com.essntl.features.invoice.ui.allinvoice

import com.essntl.core.quickbooks.data.QuickbooksInvoice

sealed interface InvoiceEvent {
    data class GetInvoices(
        val proposalId: String,
        val itineraryId: String? = null,
    ) : InvoiceEvent

    data class DownloadInvoice(val qb: QuickbooksInvoice) : InvoiceEvent
    data object ClearDownloadInvoice : InvoiceEvent
}